/**
 * @generated SignedSource<<665e16ae1e94640bebcfa0e054d0a468>>
 * @relayHash 350c8416e3a367ee9bd78c934432f93b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 611310b683ae586351fa0acbdeae4a251e95ffc4307a61b664404f8d2e8e997d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubDetailsPageQuery } from './ServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "611310b683ae586351fa0acbdeae4a251e95ffc4307a61b664404f8d2e8e997d",
    "metadata": {},
    "name": "ServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
